import React from "react";

// Real in-game Old School RuneScape locations (screenshots via the OSRS Wiki, CC BY-NC-SA),
// optimized to WebP. Cross-faded as a slow, ambient parallax backdrop.
const SCENES = [
  "/scenes/lumbridge.webp",
  "/scenes/grand_exchange.webp",
  "/scenes/catherby.webp",
  "/scenes/al_kharid.webp",
  "/scenes/white_wolf.webp",
];

const STEP = 64 / SCENES.length; // seconds between scene entrances

export default function SceneBackground({ animated = false }) {
  // Static, animation-free backdrop for first-impression pages (login/public) — guarantees
  // zero flicker/repaint jank at the exact moment a new visitor decides whether to stay.
  if (!animated) {
    return (
      <div className="scene-bg" aria-hidden="true" data-testid="scene-background">
        <div className="scene-img-static" style={{ backgroundImage: `url(${SCENES[0]})` }} />
        <div className="scene-overlay" />
      </div>
    );
  }
  return (
    <div className="scene-bg" aria-hidden="true" data-testid="scene-background">
      {SCENES.map((src, i) => (
        <div key={src} className="scene-layer" style={{ animationDelay: `${-i * STEP}s` }}>
          <div className="scene-img" style={{ backgroundImage: `url(${src})`, animationDelay: `${-i * 8}s` }} />
        </div>
      ))}
      <div className="scene-overlay" />
    </div>
  );
}
